import { createReducer } from '@reduxjs/toolkit';

import {
  updateUpdatedPipes,
  updateUpdatedSystems,
  updateUpdatedDatasets,
  updateDeletedPipes,
  updateDeletedSystems,
  updateDeletedDatasets,
  removeDeletedPipe,
  removeDeletedSystem,
} from '../thunks/liveUpdates.thunks';

import type { LiveUpdates } from '../../types/state.types';

const initialState: LiveUpdates = {
  updatedPipes: [],
  updatedSystems: [],
  updatedDatasets: [],
  deletedPipes: [],
  deletedSystems: [],
  deletedDatasets: [],
};

export const liveUpdatesReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(updateUpdatedPipes, (state, action) => {
      state.updatedPipes = action?.payload?.pipes;
    })
    .addCase(updateUpdatedSystems, (state, action) => {
      state.updatedSystems = action?.payload?.systems;
    })
    .addCase(updateUpdatedDatasets, (state, action) => {
      state.updatedDatasets = action?.payload?.datasets;
    })
    .addCase(updateDeletedPipes, (state, action) => {
      state.deletedPipes = [...state.deletedPipes, ...action?.payload?.pipes];
    })
    .addCase(removeDeletedPipe, (state, action) => {
      state.deletedPipes = state.deletedPipes.filter((pipeId) => pipeId !== action?.payload);
    })
    .addCase(updateDeletedSystems, (state, action) => {
      state.deletedSystems = [...state.deletedSystems, ...action?.payload?.systems];
    })
    .addCase(removeDeletedSystem, (state, action) => {
      state.deletedSystems = state.deletedSystems.filter(
        (systemId) => systemId !== action?.payload
      );
    })
    .addCase(updateDeletedDatasets, (state, action) => {
      state.deletedDatasets = [...state.deletedDatasets, ...action?.payload?.datasets];
    })
);
